import { render, staticRenderFns } from "./order-status-desktop.vue?vue&type=template&id=686af562&scoped=true"
import script from "./order-status-desktop.vue?vue&type=script&lang=js"
export * from "./order-status-desktop.vue?vue&type=script&lang=js"
import style0 from "./order-status-desktop.vue?vue&type=style&index=0&id=686af562&prod&lang=css"
import style1 from "./order-status-desktop.vue?vue&type=style&index=1&id=686af562&prod&scoped=true&lang=css"
import style2 from "./order-status-desktop.vue?vue&type=style&index=2&id=686af562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686af562",
  null
  
)

export default component.exports